import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import check from '../assets/check.png';
import Prompt from '../Prompt';
import Disclaimer from '../Disclaimer';
import { NavLink } from "react-router-dom";
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { view01ImageOptions } from './views/view01'

class Welcome extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            code: '',
            promptVisible: false,
            codeBoat: '',
            codePrompVisible: false
        };

        this.handleHullColorChange = this.handleHullColorChange.bind(this);
        this.handleCodeSubmit = this.handleCodeSubmit.bind(this);
        this.handleTTopChange = this.handleTTopChange.bind(this);
    }

    handleTTopChange(newValue) {
        let configuration = this.props.configuration;
        configuration.TTop = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    handleHullColorChange(newValue) {
        let configuration = this.props.configuration;
        configuration.HullColour = newValue;


        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleCodeSubmit() {
        let json = JSON.parse(atob(this.state.code));

        if (json[0] !== 'xpower') {
            if (typeof json[0] === 'string') {
                this.setState({
                    codeBoat: json[0],
                    codePrompVisible: true
                });
            }
            return;
        }

        if (this.props.onCodeSubmitted) {
            this.props.onCodeSubmitted(this.state.code);
        }

        this.setState({ promptVisible: true });

        this.timer = setTimeout(() => {
            this.setState({ promptVisible: false });
        }, 5000);
    }

    


    render() {
        let imageOptions = view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 920, height: 220 }} transform={
                [
                    0.023205, -0.020868, 0, -0.000126,
                    -0.071803, 0.001307, 0, -0.000277,
                    0, 0, 1, 0,
                    244, 350, 0, 1
                ]}>
                <ConfiguratorImage boat="Xpower" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{ position: 'relative' }}>
                    <Prompt type="info" visible={this.state.promptVisible}><Trans defaults='Configuration loaded' /></Prompt>
                    <Prompt type="error" visible={this.state.codePrompVisible}><Trans defaults='Code is for {{boat}}' values={{ boat: this.state.codeBoat }} /> <NavLink to={"/" + this.state.codeBoat + "?code=" + this.state.code}>go there</NavLink></Prompt>
                    <h1><Trans defaults='Welcome' /></h1>
                    <p><Trans defaults='Using this tool you can configure your own X-Power33C powerboat. On each step you will have a set of options. In the last step you can print out a PDF including all images and options.' /></p>
                    <h2><Trans defaults='Petestep' /></h2>

                    <p><Trans defaults='In the production of X-Power 33C, we are using the patented Petestep&reg; technology that results in a more comfortable and fuel efficient boat ride.' /></p>

                    <h2><Trans defaults='Load previous configuration' /></h2>
                    <p><Trans defaults='If you have previously been through the configurator, you get the opportunity to get your own personal code, reflecting the selections you have made throughout 14 steps. In the field below, you can load this code enabling you to see your previous configuration' /></p>
                    <button className="button" style={{ marginRight: 15 }} onClick={() => { this.setState({ expanded: !this.state.expanded }); }}><Trans defaults='Load code' /></button>
                    <div className={"expander" + (this.state.expanded ? " open" : " closed")}>
                        <p>
                            <input type="text" value={this.state.code} style={{ width: 262, verticalAlign: 'top', marginRight: 10 }} onChange={(event) => { this.setState({ code: event.target.value }); }} />
                            <button className="secondary button" onClick={this.handleCodeSubmit}><img src={check} alt="submit" /></button>
                        </p>
                    </div>
                    <Disclaimer />


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Welcome);


// WEBPACK FOOTER //
// ./src/Xpower/Welcome.js